var _defs, _circle, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#39b54a;}.cls-2{fill:#262234;}.cls-3{fill:#ffd2b4;}.cls-4,.cls-8{fill:#fff;}.cls-4{opacity:0.2;}.cls-5{opacity:0.1;}.cls-6{fill:#611c24;}.cls-7{fill:#be1e2d;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32,
    cy: 32,
    r: 27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.75,53.16a26.94,26.94,0,0,1-33.5,0L16,50.5A9.12,9.12,0,0,1,24.79,44H39.21A9.12,9.12,0,0,1,48,50.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36,39v5.76a2,2,0,0,1-1.11,1.8h0a6.46,6.46,0,0,1-5.78,0h0A2,2,0,0,1,28,44.76V39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36,44v.76a2,2,0,0,1-1.11,1.8,6.48,6.48,0,0,1-5.78,0A2,2,0,0,1,28,44.76V44H26v.76a4,4,0,0,0,2.22,3.58,8.39,8.39,0,0,0,7.56,0A4,4,0,0,0,38,44.76V44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,15.21C43.45,15.21,42.47,26,42.47,26c1.68-.17,3,.49,3,2.86s-1,2.86-2.35,3a.29.29,0,0,0-.27.27c-.39,3.69-3,6.39-5.58,8.2a9.16,9.16,0,0,1-10.56,0c-2.57-1.81-5.19-4.52-5.58-8.2a.29.29,0,0,0-.27-.27c-1.31-.13-2.35-.63-2.35-3s1.27-3,2.94-2.86C21.47,26,20.54,15.21,32,15.21Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,41.08v1.5a9.16,9.16,0,0,1-8,0v-1.5a9.16,9.16,0,0,0,8,0Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,13.62c-8.83,0-11.31,6.71-11.31,12.72A9.56,9.56,0,0,0,21,28.47c.18.72,2.07.69,2.19,0a16.75,16.75,0,0,1,1.11-6.85,1,1,0,0,1,.06-.09,12.65,12.65,0,0,0,4.29,2.77.38.38,0,0,0,.51-.47,17.62,17.62,0,0,1-.49-1.75,12.45,12.45,0,0,0,4.55,2.67.38.38,0,0,0,.49-.5c-.15-.39-.34-.89-.5-1.44a11.91,11.91,0,0,0,5.27,2,.38.38,0,0,0,.39-.58,16.86,16.86,0,0,1-1-1.83,13.24,13.24,0,0,0,2.54.86,20.68,20.68,0,0,1,.51,5.18c.11.64,2,.67,2.19,0a9.55,9.55,0,0,0,.26-2.12C43.31,20.33,40.84,13.62,32,13.62Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.37,30.64a.8.8,0,0,1-.39-.1l-2.15-1.19a.8.8,0,0,1,0-1.4L36,26.76a.8.8,0,0,1,.78,1.4l-.88.49.88.49a.8.8,0,0,1-.39,1.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.63,30.64a.8.8,0,0,1-.39-1.5l.88-.49-.88-.49a.8.8,0,1,1,.78-1.4L30.16,28a.8.8,0,0,1,0,1.4L28,30.54A.8.8,0,0,1,27.63,30.64Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35.87,33.19a1,1,0,0,1,1,1.25,5,5,0,0,1-9.68,0,1,1,0,0,1,1-1.25Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M34.42,37.57a5,5,0,0,1-4.84,0C29.78,36.34,30.79,36,32,36S34.22,36.34,34.42,37.57Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M34.87,33.19v.95a.37.37,0,0,1-.36.37h-5a.37.37,0,0,1-.36-.37v-.95Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.12,16s-1.39-2.46-6.84-3a.38.38,0,0,0-.35.61c.2.27.43.6.66,1a15.57,15.57,0,0,0-2.85.3.38.38,0,0,0-.16.68c1.22.93,3.6,3,3.06,4.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.879202e5ef30b739a8e9c164becb62d1.svg";
export { ForwardRef as ReactComponent };